import { styled } from "@mui/material/styles";
import { TreeView } from "@mui/lab";
import { Box } from "@mui/material";

export const StyledTreeView = styled(TreeView)(({ theme }) => ({
  flex: 0,
  width: "100%",
  boxShadow: "none",
  borderTop: "1px solid #EBEBF7",
  paddingTop: theme.spacing(1),
}));

export const StyledLabelWrapper = styled(Box)({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  minWidth: 0,
  width: "100%",
  "&:hover": { span: { color: "rgba(0, 0, 0, 0.5)" } },
});

export const StyledEmptyWrapper = styled(Box)(({ theme }) => ({
  width: "100%",
  padding: theme.spacing(4),
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  borderTop: "1px solid #EBEBF7",
}));
